import { GET_LIST_LOGAPI } from '../../actions/LogApiAction';

const initialState = {
  getListLogApiLoading: false,
  getListLogApiResult: false,
  getListLogApiError: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_LIST_LOGAPI:
      return {
        ...state,
        getListLogApiLoading: action.payload.loading,
        getListLogApiResult: action.payload.data,
        getListLogApiError: action.payload.errorMessage,
      };

    default:
      return state;
  }
}
